var _ellipse, _ellipse2, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2788,
    cy: 24,
    rx: 24.0698,
    ry: 24,
    fill: "#CED4DA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11446_65161",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2788,
    cy: 24,
    rx: 24.0698,
    ry: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11446_65161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.209,
    y: -1,
    width: 8,
    height: 54,
    transform: "rotate(32 34.209 -1)",
    fill: "white",
    fillOpacity: 0.101961
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11446_65161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6113 24C12.6113 17.56 17.8263 12.3333 24.2663 12.3333C30.718 12.3333 35.9447 17.56 35.9447 24C35.9447 30.44 30.718 35.6666 24.2663 35.6666C17.8263 35.6666 12.6113 30.44 12.6113 24ZM24.278 28.025L28.0347 30.2883C28.478 30.5566 29.0147 30.16 28.898 29.6583L27.9063 25.3766L31.208 22.5183C31.6047 22.18 31.3947 21.5383 30.8813 21.4916L26.518 21.1183L24.8147 17.105C24.6163 16.6266 23.9397 16.6266 23.7413 17.105L22.038 21.13L17.6747 21.5033C17.1613 21.55 16.9513 22.1916 17.3363 22.53L20.638 25.3883L19.6463 29.6583C19.5297 30.16 20.078 30.5566 20.5213 30.2883L24.278 28.025Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11446_65161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2773,
    y: 10,
    width: 28,
    height: 28,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerFeedback);
export default __webpack_public_path__ + "static/media/customer-feedback.2dfa3f14.svg";
export { ForwardRef as ReactComponent };